
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CartAdapter } from './cart.adapter';
import {Cart} from "../../../root/models";

@Injectable({
  providedIn: 'root',
})
export class CartConnector {
  constructor(protected adapter: CartAdapter) {}

  public loadAll(userId: string): Observable<Cart[]> {
    return this.adapter.loadAll(userId);
  }

  public load(userId: string, cartId: string): Observable<Cart | undefined> {
    return this.adapter.load(userId, cartId);
  }

  public create(
    userId: string,
    oldCartId?: string,
    toMergeCartGuid?: string
  ): Observable<Cart> {
    return this.adapter.create(userId, oldCartId, toMergeCartGuid);
  }

  public delete(userId: string, cartId: string): Observable<void> {
    return this.adapter.delete(userId, cartId);
  }

  public save(
    userId: string,
    cartId: string,
    saveCartName?: string,
    saveCartDescription?: string
  ): Observable<Cart> {
    return this.adapter.save(userId, cartId, saveCartName, saveCartDescription);
  }

  public addEmail(
    userId: string,
    cartId: string,
    email: string
  ): Observable<void> {
    return this.adapter.addEmail(userId, cartId, email);
  }
}
